var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"proportion-table-cell"},[_c('div',{staticClass:"proportion-quantity"},[_vm._v("\n    "+_vm._s(_vm.proportion.iSendQuantity + '/' + _vm.proportion.iQuantity +'('+_vm.proportion.cProductUnitName+')')+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }